// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type IProps = {
  name: string;
  positive?: boolean;
  enableWheel?: boolean;
};

type Props = IProps & TextFieldProps;

export default function RHFTextField({ name, positive, enableWheel, sx, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          sx={{
            '& .MuiFormHelperText-root': {
              margin: 0,
              padding: 1,
            },
            '& .MuiInputBase-input': {
              // backgroundColor: 'red',
            },
            ...sx,
          }}
          {...field}
          fullWidth
          value={field.value ?? ''}
          error={!!error}
          onFocus={(e) => {
            !enableWheel &&
              e.target.addEventListener(
                'wheel',
                function (e) {
                  e.preventDefault();
                },
                { passive: false }
              );
          }}
          onKeyPress={(event) => {
            if (positive && (event?.key === '-' || event?.key === '+')) {
              event.preventDefault();
            }
          }}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
